import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { KuiUIVue } from '@kipusystems/kipu-ui-vue'
import '@kipusystems/kipu-ui-vue/style.css'
import './app.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(KuiUIVue)

app.mount('#app')
